import AffiliationsInfoForm from './AffiliationsInfoForm';

export default AffiliationsInfoForm;
